module.exports = __webpack_public_path__ + "01_long_black.cb560a7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/01_long_black.png
// module id = Kn9r
// module chunks = 0